module.exports = __webpack_public_path__ + "img/dashboardimg.85e92c80.svg";